<template>
  <!-- TODO: Replace this old burguer and use: <Bars3Icon class="h-6 w-6" aria-hidden="true" /> -->
  <div class="seo-a--menu-toogle">
    <div class="c-hamburguer relative">
      <span />
      <span />
      <span />
      <AuthUnread :sidebar-layout="true" />
    </div>
  </div>
</template>
